import React, { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { apiInstance } from "../../helpers/axios";
import SEO from "../../components/seo";
import LayoutTwo from "../../layouts/LayoutTwo";
import CategoryItem from "./CategoryItem";
import LoadingScreen from "../../components/loading/LoadingScreen";
import noDataImg from "../../assets/images/no-data-icon.png";
import { useFetchData } from "../../helpers/api";
import Cookies from "js-cookie";
// import CollectionGridShop from "../../components/Shop/CollectionGridShop";
import ShopTopActionFilter from "../../components/product/Filters/ShopTopActionFilter";
import FilterModal from "../../components/product/Filters/FilterModal";
import "../../assets/css/product.css";
import toast from "react-hot-toast";

const pageSize = 18;
const theKey = Cookies.get("kalista-webtoken");
const cookieData = Cookies.get("kalista-web-user");
const customerData = cookieData ? JSON.parse(cookieData) : null;
const theKeyId = customerData?.Id ? customerData.Id : null;

const Category = () => {
  const { id } = useParams();
  const [isLoadingData, setLoadingData] = useState(false);
  const [isFetchingMore, setFetchingMore] = useState(false);
  const [pageOffSet, setPageOffSet] = useState(1);
  const [sortOrder, setSortOrder] = useState(1);
  const [productData, setProductData] = useState([]);
  const [productGram, setProductGram] = useState([0, 250]);
  const [productCarat, setProductCarat] = useState([0, 100]);
  const [filterModal, setFilterModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(id);
  const [selectedCollection, setSelectedCollection] = useState([]);
  const [sendCustomData, setSendCustomData] = useState(false);
  const [customFilterData, setCustomFilterData] = useState([
    {
      Id: 0,
      Shape: "ROUND",
      Size: "",
      Weight: "",
      Pcs: "",
      SizeCode: "",
      CustomerId: Number(theKeyId),
    },
  ]);

  const { data: singleOrderData, isLoading } = useFetchData(
    ["totalProductsCount", selectedCategory, selectedCollection],
    "/Customer/TotalProducts",
    { GrpNo: selectedCategory, DesgGroupNo: null },
    null,
    { staleTime: 5 * 60 * 1000 }
  );

  const excludedGrpNos = ["7", "9", "10", "12", "67", "72", "74", "79"];
  const { data: prductSizeData, isLoadingSize } = useFetchData(
    ["prductSizes", selectedCategory, selectedCollection],
    "/Customer/GetItemSize",
    { CategoryId: selectedCategory },
    id,
    {
      staleTime: 5 * 60 * 1000,
      enabled: !excludedGrpNos.includes(selectedCategory),
    }
  );

  const totalProducts = singleOrderData?.Data || 50;

  const getProducts = useCallback(
    async (resetData = null, status = false) => {
      if (productData.length >= totalProducts) return;
      setLoadingData(true);
      setFetchingMore(true);
      setFilterModal(false);

      const hasValidSize =
        customFilterData.length > 0 &&
        customFilterData.some((item) => item.Size !== "");

      const data = resetData ?? {
        CategoryId: selectedCategory,
        CurrentPage: pageOffSet,
        PageSize: pageSize,
        SortOrder: Number(sortOrder),
        Status: "All",
        NetWtFrom: productGram[0],
        NetWtTo: productGram[1],
        DiamondWtFrom: productCarat[0],
        DiamondWtTo: productCarat[1],
        ...(selectedCollection.length > 0
          ? { DesgGroupNo: selectedCollection }
          : {}),
        ...(status && hasValidSize ? { customFilterData } : {}),
      };

      try {
        const response = await apiInstance.post(
          "/Customer/getProductList",
          data
        );

        if (response.status === 200) {
          setProductData((prevData) => [
            ...prevData,
            ...(response.data?.Data || []),
          ]);
        } else {
          toast.error(response.data.Message || "Something went wrong!");
          throw new Error(response.data.Message || "Something went wrong!");
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingData(false);
        setFetchingMore(false);
      }
    },
    // eslint-disable-next-line
    [
      id,
      pageOffSet,
      isFetchingMore,
      sortOrder,
      productGram,
      productCarat,
      selectedCategory,
      selectedCollection,
      customFilterData,
    ]
  );

  useEffect(() => {
    setProductData([]);
    setPageOffSet(1);
  }, [id, sortOrder]);

  useEffect(() => {
    if (selectedCollection.length > 0) {
      getProducts();
    }
    // eslint-disable-next-line
  }, [selectedCollection]);

  useEffect(() => {
    setSortOrder(1);
    setProductGram([0, 250]);
    setProductCarat([0, 100]);
    setSelectedCategory(id);
  }, [id]);

  useEffect(() => {
    if (sendCustomData) {
      getProducts(null, true);
    } else {
      getProducts();
    }
    // eslint-disable-next-line
  }, [pageOffSet, sortOrder, selectedCategory]);

  useEffect(() => {
    let isThrottled = false;
    const handleScroll = () => {
      if (isThrottled || productData.length >= totalProducts || isFetchingMore)
        return;

      if (
        window.innerHeight + window.scrollY >=
          document.body.scrollHeight * 0.95 &&
        !isFetchingMore
      ) {
        isThrottled = true;
        setTimeout(() => (isThrottled = false), 300);
        setPageOffSet((prev) => prev + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetchingMore, productData?.length, singleOrderData]);

  const filterProducts = () => {
    setProductData([]);
    setPageOffSet(1);
    getProducts();
  };
  const resetFilters = () => {
    setSendCustomData(false);

    const resetData = {
      CategoryId: Number(id),
      CurrentPage: 1,
      PageSize: pageSize,
      SortOrder: 1,
      Status: "All",
      NetWtFrom: 0,
      NetWtTo: 250,
      DiamondWtFrom: 0,
      DiamondWtTo: 100,
    };

    setSelectedCategory(id);
    setSelectedCollection([]);
    setProductData([]);
    setPageOffSet(1);
    setProductGram([0, 250]);
    setProductCarat([0, 100]);
    setSortOrder(1);

    getProducts(resetData);
  };

  return (
    <>
      <SEO titleTemplate="Category Page" description="Category Page" />
      <LayoutTwo>
        <div className="container">
          <ShopTopActionFilter
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            setFilterModal={setFilterModal}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            selectedCollection={selectedCollection}
            setSelectedCollection={setSelectedCollection}
            productGram={productGram}
            setProductGram={setProductGram}
            productCarat={productCarat}
            setProductCarat={setProductCarat}
            setProductData={setProductData}
            pageOffSet={pageOffSet}
            setPageOffSet={setPageOffSet}
            filterProducts={filterProducts}
            resetFilters={resetFilters}
            sendCustomData={sendCustomData}
            setSendCustomData={setSendCustomData}
            getProducts={getProducts}
          />
          {(isLoadingData || isLoading || isLoadingSize) &&
          productData?.length === 0 ? (
            <LoadingScreen />
          ) : productData?.length === 0 ? (
            <div className="product_grid no_data">
              <div className="empty_icon_con">
                <img src={noDataImg} alt="NO Data Icon" />
                <p>No Data Found.</p>
              </div>
            </div>
          ) : (
            <div className="shop-bottom-area mt-30 mb-50">
              <section className="product_grid">
                {productData?.map((product, index) => (
                  <React.Fragment key={index}>
                    <CategoryItem
                      product={product}
                      pageSize={pageSize}
                      prductSizeData={prductSizeData?.Data}
                    />
                    {/* {(index + 1) % 6 === 0 && index + 1 < pageSize && (
                      <CollectionGridShop />
                    )} */}
                  </React.Fragment>
                ))}
              </section>
              {isFetchingMore && <LoadingScreen />}
              {!isFetchingMore && !theKey && productData?.length >= 45 ? (
                <div className="product_login_section">
                  <div className="modal-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="#5a9a8f"
                    >
                      <path d="M12 1a5 5 0 0 1 5 5v3H7V6a5 5 0 0 1 5-5zm3 8V6a3 3 0 1 0-6 0v3h6zm-3 11a3 3 0 0 1-3-3 3 3 0 0 1 3-3 3 3 0 0 1 3 3 3 3 0 0 1-3 3z" />
                      <path d="M4 11a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2H4z" />
                    </svg>
                  </div>
                  <h4>See More Designs</h4>
                  <p>
                    Join us to unlock our full collection of exclusive designs.
                  </p>
                  <div className="button_con">
                    <Link to="/login" className="login_btn">
                      Login
                    </Link>
                    <Link to="/register" className="login_btn">
                      Register
                    </Link>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          )}
        </div>
      </LayoutTwo>
      {filterModal && (
        <FilterModal
          show={filterModal}
          onHide={() => setFilterModal(false)}
          customFilterData={customFilterData}
          setCustomFilterData={setCustomFilterData}
          getProducts={getProducts}
          setProductData={setProductData}
          setPageOffSet={setPageOffSet}
          sendCustomData={sendCustomData}
          setSendCustomData={setSendCustomData}
        />
      )}
    </>
  );
};

export default Category;
